'use client';
import React, { useState } from 'react';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons/faArrowRightLong';
import Image from 'next/image';

const CallToActionForm = React.lazy(() =>
  import('@benzinga/forms-ui').then(module => ({
    default: module.CallToActionForm,
  })),
);

export interface FinancialAdvisorInfoCardProps {
  data: any;
  formData?: any;
}

export const FinancialAdvisorInfoCard: React.FC<FinancialAdvisorInfoCardProps> = ({ data, formData }) => {
  const PayStructure: string | any[] = data.pay_structure;
  const Services: string | any[] = data.services;
  const [showForm, setShowForm] = useState(false);
  return (
    <FinancialAdvisorInfoCardContainer className="">
      <div className="financial-advisor-information-card  ">
        {!data.claimed_profile && showForm && (
          <div className="bz3-v5-popup bz3-popup-financial-advisor">
            <div className="claim-profile-popup-inner mr-auto ml-auto relative mt-24 lg:w-4/12 md:w-6/12 sm:w-8/12 w-11/12">
              <div className="financial-advisor-claim-profile-popup bg-white p-6 shadow-border rounded-lg">
                <h2 className="leading-5 font-manrope text-left text-2xl font-bold pb-3 uppercase">Claim Profile</h2>
                <p className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium pb-6">
                  Reach out to our team to improve your companies visibility
                </p>
                <div
                  className="absolute right-5 top-5 text-blue-light_30 mb-1 font-medium text-xl bz3-v5-close-popup cursor-pointer"
                  onClick={() => setShowForm(!showForm)}
                >
                  <Icon icon={faTimes} />
                </div>
                <div className="bz3-popup-financial-advisor-inner">
                  <React.Suspense fallback={<div />}>
                    <CallToActionForm
                      beehiivFormId="c03f46e3-b180-439f-8cf4-103cbf2ac567"
                      extraFields={formData || undefined}
                    />
                  </React.Suspense>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="financial-advisor-information-card bg-white p-4 border-blue-light_10 border rounded mb-4 wide relative ">
          <div className="sm:flex sm:space-x-2 align-middle">
            <div className="bz4-facet-wealth-icon image-wrapper sm:w-1/6 w-5/6 p-1 text-center border-blue-light_10 border rounded sm:mb-0 mb-1 bg-blue-light_5">
              <Image
                alt={data.name}
                className="lazy rounded-full max-h-8 entered loaded m-auto"
                height={32}
                src="https://www.benzinga.com/wp-content/themes/benzinga-money/resources/assets/images/building.svg"
                title={data.name}
                width={72}
              />
            </div>
            <div className="w-full">
              <div className="sm:flex sm:space-x-2 align-middle">
                <div className="sm:w-3/4 w-full mt-3 sm:mt-0">
                  {data.sub_title && (
                    <h6 className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-0.5 font-medium">
                      {data.sub_title}
                    </h6>
                  )}
                  {data.name && <h3 className="firm-name">{data.name}</h3>}
                </div>
                <div className="sm:w-1/4 w-full sm:text-right mt-4 sm:mt-0">
                  {!data.claimed_profile && (
                    <div className="sm:relative text-center bottom-4 left-4 right-4 sm:bottom-0 sm:left-0 sm:right-0 font-manrope bg-blue-light_100 bg-opacity-5 border-blue-light_100 border mt-0 border-opacity-25 text-white p-3 rounded inline-block align-middle uppercase py-2.5 text-blue-light_100 font-bold text-sm hover:bg-opacity-100 hover:text-blue-light_5 sm:text-xs open-claim-profile-popup">
                      <button onClick={() => setShowForm(!showForm)}>Claim Profile</button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="sm:w-1/12 text-right sm:relative absolute top-6 right-4 sm:right-0 sm:top-0 ">
              <div className="text-blue-light_30 p-2">
                <a href="#">
                  <Icon icon={faChevronUp} />
                </a>
              </div>
            </div>
          </div>
          <div className="block sm:flex overflow-hidden mt-4 sm:mt-6">
            <div className="w-full sm:w-1/2">
              <div className="assets-managed-wrapper">
                <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                  Assets Managed
                </label>
                <div className="assets-managed-value">{data.assets_managed}</div>
              </div>
              {data.firm_description && (
                <div className="assets-managed-description">
                  <p className="leading-5 font-manrope text-left text-sm text-blue-light_50 mb-1 font-medium mt-4">
                    {data.firm_description}
                  </p>
                </div>
              )}
              <div className="mt-2 sm:mt-8">
                <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                  Pay Structure
                </label>
                <div className="leading-5 font-manrope text-left text-sm text-blue-nocollight_30 font-bold">
                  {Array.isArray(PayStructure) && (
                    <ul className="card-ul-blue-bullet">
                      {PayStructure.map(name => (
                        <li>{name}</li>
                      ))}
                    </ul>
                  )}
                  {!Array.isArray(PayStructure) && <div>{PayStructure}</div>}
                </div>
              </div>
              {data.review_url && (
                <div className="font-manrope uppercase bg-blue-light_100 text-blue-light_5 p-3 rounded  text-sm text-bold inline-block btn-read-review bg-no-repeat hover:bg-blue-dark hover:text-blue-light_5 inline-flex items-center mt-4">
                  <a href="https://dev.ashok.zingbot.bz/money/bitcoin-mining-software/">
                    Read Review <Icon className="mr-2 ml-4" icon={faArrowRightLong} />
                  </a>
                </div>
              )}
            </div>
            <div className="w-full sm:w-1/2 mt-4 sm:mt-0">
              <div className="grid grid-cols-2 gap-2">
                <div className="">
                  <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                    Account Minimum
                  </label>
                  {data.account_minimum && (
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      {data.account_minimum}
                    </div>
                  )}
                  {!data.account_minimum && (
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      <span>N/A</span>
                    </div>
                  )}
                </div>
                <div className="">
                  <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                    No. of Advisors
                  </label>
                  {data.num_financial_advisors && (
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      {data.num_financial_advisors}
                    </div>
                  )}
                  {!data.num_financial_advisors && (
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      <span>N/A</span>
                    </div>
                  )}
                </div>
                <div className="">
                  <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                    No. of Clients
                  </label>
                  <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                    {data.num_financial_planning_clients}
                  </div>
                </div>

                {/* <!-- works_with_high_net_worth_indvs --> */}
                {data.works_with_high_net_worth_indvs && (
                  <div className="">
                    <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                      Net Worth Advisors
                    </label>
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      {data.works_with_high_net_worth_indvs}
                    </div>
                  </div>
                )}

                {/* <!-- match_percentage --> */}
                {data.match_percentage && (
                  <div className="">
                    <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                      Match Percentage
                    </label>
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      {data.match_percentage}
                    </div>
                  </div>
                )}
                {/* <!-- score --> */}
                {data.score && (
                  <div className="">
                    <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                      Score
                    </label>
                    <div className="leading-5 font-manrope text-left sext-sm sm:text-lg text-blue-nocollight_30 font-bold">
                      {data.score}
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-2 sm:mt-8">
                <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-1 font-medium">
                  Services
                </label>
                <div className="leading-5 font-manrope text-left text-sm text-blue-nocollight_30 font-bold">
                  {Array.isArray(Services) && (
                    <ul className="card-ul-blue-bullet">
                      {Services.map(name => (
                        <li>{name}</li>
                      ))}
                    </ul>
                  )}
                  {!Array.isArray(Services) && <div>{Services}</div>}
                </div>
              </div>
            </div>
          </div>
          <div className="block sm:flex hidden sm:hidden md:hidden lg:hidden overflow-hidden mt-0 sm:mt-6 border-solid rounded border-blue-light_100 border border-opacity-25 p-2 sm:pr-4 sm:pl-5 sm:py-4 bg-blue-light_100 bg-opacity-5">
            <div className="w-full sm:w-3/4 flex align-middle">
              <div className="pr-0 mr-2 sm:pr-5 w-2/12 sm:mr-0 sm:w-auto">
                <img
                  alt="Premium"
                  src="https://staging.ashok.zingbot.bz/wp-content/themes/benzinga-money/resources/assets/images/lock.svg"
                  title="Premium"
                ></img>
              </div>
              <div className="">
                <p className="text-blue-light_40 font-manrope text-blue-nocollight_30 text-sm not-italic w-full leading-5 m-0 font-bold uppercase">
                  Available for Premium
                </p>
                <label className="leading-5 font-manrope text-left text-sm text-blue-light_30 font-medium">
                  Premium subscription will give you more options.
                </label>
              </div>
            </div>
            <div className="w-full sm:w-auto text-center sm:text-right sm:align-middle mt-2 sm:mt-0">
              <div className="font-manrope bg-blue-light_100 bg-opacity-5 border-blue-light_100 border border-opacity-25 text-white p-6 rounded inline-block align-middle uppercase py-2.5 text-blue-light_100 font-bold text-sm hover:bg-opacity-100 hover:text-blue-light_5">
                <a href="#">unlock</a>
              </div>
            </div>
          </div>

          <div className="block overflow-hidden mt-6 border-solid rounded border-blue-light_100 border border-opacity-25 sm:pr-4 sm:pl-5 sm:py-4 p-2 bg-blue-light_100 bg-opacity-5 relative">
            {data.address_line_1 && data.address_line_2 && (
              <div className="">
                <h6 className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-0.5 font-medium">
                  Address
                </h6>
                <p className="text-blue-light_40 font-manrope text-blue-nocollight_30 text-sm not-italic w-full leading-5 m-0 font-bold uppercase mb-1">
                  {data.address_line_1}
                  {data.address_line_2}
                </p>
              </div>
            )}
            <div className="block sm:flex ">
              <div className="mb-3 sm:mb-0 sm:mr-6">
                <h6 className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-0.5 font-medium">
                  Phone number
                </h6>
                <p className="text-blue-light_40 font-manrope text-blue-nocollight_30 text-sm not-italic w-full leading-5 m-0 font-bold uppercase mb-1">
                  {data.phone_number}
                </p>
                <div className="sm:relative text-center bottom-4 left-4 right-4 sm:bottom-0 sm:left-0 sm:right-0 font-manrope bg-blue-light_100 bg-opacity-5 border-blue-light_100 border mt-0 border-opacity-25 text-white p-3 rounded inline-block align-middle uppercase py-2.5 text-blue-light_100 font-bold text-sm hover:bg-opacity-100 hover:text-blue-light_5 absolute sm:mt-4 hidden">
                  <a href="#">free consultation</a>
                </div>
              </div>
              <div className="mb-16 sm:mb-0 hidden">
                <h6 className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-0.5 font-medium hidden">
                  Email address
                </h6>
                <p className="text-blue-light_40 font-manrope text-blue-nocollight_30 text-sm not-italic w-full leading-5 m-0 font-bold mb-1 hidden">
                  bluewater-management@gmail.com
                </p>
                <p className="text-blue-light_40 font-manrope text-blue-nocollight_30 text-sm not-italic w-full leading-5 m-0 font-bold mb-3 sm:mb-1 hidden">
                  bluewater-asset@gmail.com
                </p>
                <h6 className="leading-5 font-manrope text-left text-sm text-blue-light_30 mb-0.5 font-medium mt-0 sm:mt-7">
                  Get a free a 15 minute meeting
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FinancialAdvisorInfoCardContainer>
  );
};

const FinancialAdvisorInfoCardContainer = styled.div`
  .m-auto {
    margin: 0 auto;
  }
  .bg-blue-light_5 {
    --tw-bg-opacity: 1;
    background-color: rgba(242, 248, 255, 1);
  }
  .text-blue-light_30 {
    --tw-text-opacity: 1;
    color: rgba(153, 174, 204, var(--tw-text-opacity));
  }
  .text-blue-light_100 {
    --tw-text-opacity: 1;
    color: rgba(26, 121, 255, var(--tw-text-opacity));
  }
  .text-blue-light_100 {
    --tw-text-opacity: 1;
    color: rgba(26, 121, 255, var(--tw-text-opacity));
    &:hover {
      color: #f2f8ff;
    }
  }
  .bg-opacity-5 {
    --tw-bg-opacity: 0.05;
  }
  .bg-blue-light_100 {
    --tw-bg-opacity: 1;
    background-color: rgba(26, 121, 255, var(--tw-bg-opacity));
    &.bg-opacity-5 {
      background-color: #f3f8ff;
      &.open-claim-profile-popup {
        &:hover {
          background-color: #1c78fc;
        }
      }
    }
  }

  .border-blue-light_100 {
    --tw-border-opacity: 1;
    border-color: rgba(26, 121, 255, var(--tw-border-opacity));
    &.border-opacity-25 {
      border-color: #bdd6fd;
    }
  }
  .text-blue-light_5 {
    --tw-text-opacity: 1;
    color: rgba(242, 248, 255, var(--tw-text-opacity));
  }
  .text-bold {
    font-weight: 700;
  }
  .btn-read-review {
    &:hover {
      --tw-bg-opacity: 1;
      background-color: rgba(0, 45, 69, var(--tw-bg-opacity));
    }
  }
  .text-blue-nocollight_30 {
    --tw-text-opacity: 1;
    color: rgba(40, 61, 89, var(--tw-text-opacity));
  }
  .image-wrapper {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .firm-name {
    color: rgba(40, 61, 89, 1);
    @media (min-width: 640px) {
      font-size: 1rem;
    }
    line-height: 1.25rem;
    font-style: normal;
    text-transform: uppercase;
    font-weight: 700;
    width: 100%;
    margin: 0px;
    font-size: 1rem;
  }
  .assets-managed-value {
    color: ${({ theme }) => theme.colorPalette.blue500};
    line-height: 1.25rem;
    font-weight: 700;
    font-size: 1.125rem;
    text-align: left;
  }
  .card-ul-blue-bullet {
    margin-left: unset;

    li {
      position: relative;
      list-style-type: none;
      margin-left: 16px;
      &:before {
        content: '';
        position: absolute;
        top: 0.5rem;
        left: 0;
        left: -1rem;
        height: 0.375rem;
        width: 0.375rem;
        list-style-type: none;
        border-radius: 9999px;
        --tw-bg-opacity: 1;
        background-color: rgba(26, 121, 255, var(--tw-bg-opacity));
      }
    }
  }
  .bz3-v5-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 50;
    height: 100vh;
    overflow-y: auto;
    --tw-bg-opacity: 1;
    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
    --tw-bg-opacity: 0.5;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
  }

  .call-to-action-container {
    box-shadow: unset !important;
    &:hover {
      box-shadow: unset !important;
    }
    border: unset !important;
    border-radius: 0 !important;
    .hubspot-form-wrapper {
      border: unset;
      padding: 0;
      span {
        &.text-gray {
          display: none;
        }
        display: none;
      }

      .hubspot-form {
        border: unset;
        background-color: unset;
        padding: unset;
      }

      .hubspot-input {
        background-color: rgba(26, 121, 255, 1);
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0.25rem;
        border-width: 1px;
        --tw-border-opacity: 1;
        border-color: rgba(225, 235, 250, 1);
        --tw-bg-opacity: 1;
        background-color: rgba(184, 203, 229, var(--tw-bg-opacity));
        --tw-bg-opacity: 0.2;
        font-size: 1rem;
        line-height: 1.5rem;
        --tw-text-opacity: 1;
        color: rgba(153, 174, 204, 1);
        margin-bottom: 10px;
      }
      button {
        display: inline-block;
        width: 100%;
        border-radius: 0.25rem;
        --tw-bg-opacity: 1;
        background-color: rgba(26, 121, 255, 1);
        --tw-text-opacity: 1;
        color: rgba(242, 248, 255, 1);
        width: 100%;
        padding: 0.75rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-weight: 700;
        text-transform: uppercase;
        --tw-text-opacity: 1;
        color: rgba(242, 248, 255, 1);
        &:hover {
          background-color: rgba(0, 45, 69, 1);
        }
        &:before {
          content: 'SUBMIT REQUEST';
        }
      }
    }
    > div:last-of-type {
      padding: 0 !important;
    }
  }
  > div:last-of-type {
    padding: 0 !important;
  }
`;
